import React from 'react'
import UiMainWrapper from "../../components/common/UiMainWrapper"
import TopHeader from "../../components/header/TopHeader"
import ShopInnerBanner from "./Views/ShopInnerBanner"
import { UiBannerBottomBar } from '../../components/common/UiBannerBottomBar';
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../components/grid-container/GridContainer"
import {
    UiContentWr,

} from "../../components/common/UiPageElements"
import OrderContent from "./Views/OrderContent"
import OrderPointSection from "./Views/OrderPointSection"
import PaymentInformation from "./Views/PaymentInformation"
import Footer from "../../components/footer/Footer"

export default function OrderCheckout(props) {

    return (
        <>
            <UiMainWrapper>
                <TopHeader />
                <ShopInnerBanner title="Order Checkout"
                    description="Product Description Text" />
                <UiBannerBottomBar
                    prevPage="Shop"
                    prevPageLink="/ui"
                    currentPage="Broswe All Products"
                    currentPageLink="/ui/incentives-pre-register" />
                <UiContentWr>
                    <UiRowContainer fluid="fluid" >
                        <UiCol lg="4" xl="4">
                           <OrderPointSection/>
                        </UiCol>
                        <UiCol lg="8" xl="8">
                            <OrderContent/>
                        </UiCol>
                        <UiCol lg="12" xl="12">
                            <PaymentInformation/>
                        </UiCol>
                        
                    </UiRowContainer>
                </UiContentWr>
                <Footer />
            </UiMainWrapper>
        </>
    )
}

